import { useStatusButtonStyles } from "./ConfirmButton";
import { T } from "../../util/t";
import { AutoProgressButton } from "../forms/fields/AutoProgressButton";
import { useReinstateEntry } from "./useReinstateEntry";

export const ReinstateButton = ({ entry, isTeams }) => {
    const reinstateEntry = useReinstateEntry(
        entry.eventDivisionId,
        entry.athlete.id,
        isTeams,
    );
    const classes = useStatusButtonStyles();

    return (
        <AutoProgressButton
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={reinstateEntry}
        >
            <T>Reinstate</T>
        </AutoProgressButton>
    );
};
